

import Event = createjs.Event;

export class BasicFirstVisitEvent extends Event {
    public static AVATARCREATION_FINISHED: string = "avaFinished";

    constructor(type: string, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);
    }
}

